export const FEATURES = [
  {
    slug: 'themes',
    title: 'Thèmes personnage & thread',
    summary: 'Personnalisez les couleurs et le filigrane de vos personnages et de vos discussions, sans imposer votre style aux autres joueurs.',
    category: 'Personnalisation',
  },
];

export function getFeatureBySlug(slug) {
  return FEATURES.find((feature) => feature.slug === slug) || null;
}
